<template>
  <el-scrollbar
    ref="scrollbarContainer"
    height="100vh"
    @scroll="scrollFun"
    wrapRef="allDiv"
  >
    <div
      class="flex flex-col min-h-screen"
      ref="allDiv"
      @contextmenu.prevent
      @dragstart.prevent
    >
      <keep-alive>
        <HeaderBar></HeaderBar>
      </keep-alive>
      <!-- <HeaderBar></HeaderBar> -->
      <div style="width: 1200px; margin: 0 auto; flex: 1" flag="flag">
        <router-view />
      </div>
      <Footer />
      <GraphicCaptchaDialog />
    </div>
  </el-scrollbar>
</template>
<script setup>
import { onMounted, ref } from "vue";
import HeaderBar from "./components/App/HeaderBar.vue";
import Footer from "./components/App/Footer.vue";
import GraphicCaptchaDialog from "./components/GraphicCaptchaDialog.vue";
import Bus from "@utils/bus.js";

// let that = reactive({
//     width: 1920,
//     height: 1080,
//     scaleX: null,
//     scaleY: null,
// });
// let styleObject = computed(() => {
//     let obj = {
//         width: that.width + "px",
//         height: that.height + "px",
//     };
//     return obj;
// });

// const getScale = () => {
//     // 分别计算X轴和Y轴的缩放比例
//     that.scaleX = window.innerWidth / that.width;
//     that.scaleY = window.innerHeight / that.height;
// };

// const setScale = debounce(() => {
//     // 获取到缩放比，设置它
//     getScale();
// }, 500);

// onMounted(() => {
//     getScale();
//     window.addEventListener("resize", setScale);
// });

// onUnmounted(() => {
//     window.addEventListener("resize", setScale);
// });

const scrollbarContainer = ref(null);

function scrollFun(event) {
  const scrollTop = event.scrollTop || 0;
  Bus.$emit("scrollChange", {
    scrollTop,
    // deltaY // 传递滚轮方向
  });
}

function toTop() {
  const scrollContainer = scrollbarContainer.value;
  if (scrollContainer) {
    scrollbarContainer.value.setScrollTop(0);
  }
}

// 监听 Bus 事件
Bus.$on("scrollToTop", () => {
  toTop();
});

// 在组件挂载后，确保 ref 已经被正确设置
onMounted(() => {
  // console.log('scrollbarContainer:', scrollbarContainer.value);
});
</script>

<style lang="scss">
// el-dialog 不显示滚动条
.el-overlay-dialog,
.el-overlay.is-message-box .el-overlay-message-box,
.el-popup-parent--hidden {
  overflow-y: auto;
}

body.no-scroll {
  overflow: hidden;
}
.el-message-box {
  width: 344px !important;
  // height: 159px !important;
  padding: 24px 20px !important;
  border: 2px solid #47496f !important;
  border-radius: 16px !important;

  .el-message-box__header {
    // display: flex;
    // justify-content: start;
    padding-left: 0px;
    padding-right: 0px;
    align-items: center;
    color: #000;
    padding-bottom: 30px;

    .el-message-box__headerbtn {
      display: none;
    }
  }
   .show-close {
      padding-right: 0px !important;
    }
  .el-message-box__content {
    display: none;
  }

  .el-message-box__btns {
    display: flex;
    justify-content: space-around;
    padding: 0;

    .el-button {
      width: 140px;
      height: 46px;
      line-height: 46px;
      border-radius: 6px;
      background: #fff;
      text-align: center;
      font-size: 14px;
      color: #000;
      border: 1px solid #c9cad6;
    }

    .el-button.el-button--primary {
      color: #ffffff;
      background: #47496f;
    }
  }
}
</style>
